import Colors from "../../../../theme/colors";

const style = {
  container: {
    color: Colors.white,
  },
  tableHeadCell: {
    // fontSize: "14px",
    // backgroundColor: "#DDDDDD",
    // border: "none",
    // color: "rgba(94, 94, 94, 1)",
    // fontWeight: 700,
    padding: "18px 10px",
    // textOverflow: "ellipsis",
    // whiteSpace: "nowrap",
    // textAlign: "center",
    fontSize: "14px",
    border: "none",
    // padding: "18px 8px 18px 0",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // backgroundColor: "#DDDDDD",
    whiteSpace: "nowrap",
    color: "red",
    fontWeight: "600",
  },
  tableBody: {
    // backgroundColor: Colors.white,
    // border: "none",
    // color: Colors.white,
    fontSize: "14px",
    border: "none",
    color: "#000000",
  },
  emptyList: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem",
    width: "100%",
    border: "1px solid #BFCFE1",
  },
};

export default style;
